import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const today = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function WeeklyPayments() {
  const [week, setWeek] = useState(today);
  const onWeekChange = useCallback((event) => setWeek(event.target.value), []);

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [playerSelect, setPlayerSelect] = useState(0);
  const onPlayerSelectChange = useCallback(
    (event) => setPlayerSelect(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Week Of"
          type="date"
          value={week}
          size="small"
          onChange={onWeekChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <div>
          <SubGroup title="Players Selection">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={playerSelect}
                onChange={onPlayerSelectChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Non Zero Bal"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="All Players"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Weekly Balance Report"
        groupBy="idAgent"
        getUrl={() => "/Reports/Report_Weekly_Payments"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          DateWeek: week,
          Book: book,
          LineType: lineType,
          Group: group,
          Office: office,
          AgentTo: agentTo,
          AgentFrom: agentFrom,
          Distributor: distributor,
          PlayerSelect: playerSelect,
        })}
        getProcess={(data) =>
          data.map((item) => {
            const total =
              item.day1 +
              item.day2 +
              item.day3 +
              item.day4 +
              item.day5 +
              item.day6 +
              item.day7;

            return {
              ...item,
              total,
            };
          })
        }
        getTotals={(data) => ({
          player: `Totals, ${data.length} Players`,
          day1: data.reduce((acc, item) => acc + item.day1, 0),
          day2: data.reduce((acc, item) => acc + item.day2, 0),
          day3: data.reduce((acc, item) => acc + item.day3, 0),
          day4: data.reduce((acc, item) => acc + item.day4, 0),
          day5: data.reduce((acc, item) => acc + item.day5, 0),
          day6: data.reduce((acc, item) => acc + item.day6, 0),
          day7: data.reduce((acc, item) => acc + item.day7, 0),
          total: data.reduce((acc, item) => acc + item.total, 0),
        })}
        getGlobalTotals={(data) => ({
          player: `Totals`,
          day1: data.reduce((acc, item) => acc + item.day1, 0),
          day2: data.reduce((acc, item) => acc + item.day2, 0),
          day3: data.reduce((acc, item) => acc + item.day3, 0),
          day4: data.reduce((acc, item) => acc + item.day4, 0),
          day5: data.reduce((acc, item) => acc + item.day5, 0),
          day6: data.reduce((acc, item) => acc + item.day6, 0),
          day7: data.reduce((acc, item) => acc + item.day7, 0),
          total: data.reduce((acc, item) => acc + item.total, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day1"
          dataFormat={decimalInvertedReportFormatter}
        >
          Mon
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day2"
          dataFormat={decimalInvertedReportFormatter}
        >
          Tue
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day3"
          dataFormat={decimalInvertedReportFormatter}
        >
          Wed
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day4"
          dataFormat={decimalInvertedReportFormatter}
        >
          Thu
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day5"
          dataFormat={decimalInvertedReportFormatter}
        >
          Fri
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day6"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sat
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="day7"
          dataFormat={decimalInvertedReportFormatter}
        >
          Sun
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="total"
          dataFormat={decimalInvertedReportFormatter}
        >
          Total
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default WeeklyPayments;
